import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

export const tokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const token$ = inject(AuthService).bearerToken();

  return token$.pipe(
    switchMap((token) => {
      const validUrl =
        req.url.startsWith(environment.api.root) ||
        req.url.startsWith(environment.api.course) ||
        req.url.startsWith(environment.api.identity.root);
      if (token && validUrl) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      return next(req);
    }),
  );
};
